/* src/app/address-book-search/address-book-dialog/address-book-search-dialog.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.address-book-dialog {
  width: 100%;
}
.address-book-dialog .mat-mdc-dialog-content {
  padding: 1em 2em;
}
.address-book-dialog .mat-mdc-dialog-content ::ng-deep .dataTables_wrapper {
  padding: 0;
}
.address-book-dialog .address {
  display: table-cell;
  width: 100%;
  max-width: 250px;
}
.address-book-dialog ::ng-deep .dtr-details .dtr-data .address {
  max-width: 100%;
}
.address-book-dialog .contact-name {
  max-width: 120px;
}
.address-book-dialog .company-name {
  max-width: 130px;
}
.address-book-dialog .contact-name,
.address-book-dialog .company-name {
  display: table-cell;
}
.address-book-dialog table.dataTable thead th,
.address-book-dialog table.dataTable thead td {
  padding: 8px 10px;
}
.address-book-dialog .country {
  line-height: 18px;
  max-width: 70px;
  white-space: normal;
}
/*# sourceMappingURL=address-book-search-dialog.component.css.map */
